export class ChannelOrderRegionEntity {
  id?: number
  profileImageUrl?: string | null
  color?: string | null
  name?: string | null
  subtitle?: string | null
  order?: number | null
}
